import React, { useState } from 'react'

import { Box, Button, Checkbox, FormControlLabel, FormGroup, IconButton } from '@mui/material'

import { useNavigate } from 'react-router-dom'
import CustomPagination from '../components/CustomPagination';
import FilterMenu from '../components/filterMenu';
import SearchBar from '../components/SearchBar';
import MainContainer from '../layout/MainContainer';
import SubscriptionTable from '../pages/manage-subscription/subscriptionTable';



export const CoupanManagement = () => {
    const navigate = useNavigate();

    const [searchTerm, setSearchTerm] = useState('');

    return (
        <MainContainer>
            <div className="main_title d_flex">
                <div className="left_s">
                    <h1 className="">
                     
                     Coupon Management
                    </h1>
                </div>


                <div className="right_s">
                    <div className="left_s">
                        <Box className="search_box">
                            <SearchBar
                                searchTerm={searchTerm}
                                setDebouncedSearchTerm={setSearchTerm}
                                placeholder="Search status & membership"
                            />
                        </Box>
                    </div>
                    <Button className='btn btn_primary' onClick={()=> navigate('/manage-coupan/add')}>+ Add Coupan</Button>
                  <FilterMenu />
                </div>
            </div>


        <div className="cards table_cards">
            <SubscriptionTable />
        </div>
        <CustomPagination />

        </MainContainer>
    )
}

export default CoupanManagement;
